var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

import { css } from '@creditas-ui/system';
import { variant } from '@creditas-ui/utilities';
export var base = function base(_ref) {
  var button = _ref.theme.button;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border: none;\n  overflow: hidden;\n  width: auto;\n  color: ", ";\n  letter-spacing: ", "px;\n  font-family: ", ";\n  background-color: ", ";\n"])), button('primary.fontColor'), button('primary.letterSpacing'), button('primary.fontFamily'), button('primary.color'));
};
export var sizes = function sizes(_ref2) {
  var button = _ref2.theme.button;
  return variant({
    prop: 'size',
    variants: {
      small: {
        borderRadius: button('primary.radius.small'),
        paddingX: button('primary.spacingX.small.textOnly'),
        paddingY: button('primary.spacingY.small.textOnly'),
        lineHeight: button('primary.lineHeight.small'),
        fontSize: button('primary.fontSize.small'),
        fontWeight: button('primary.fontWeight.small')
      },
      medium: {
        borderRadius: button('primary.radius.medium'),
        paddingX: button('primary.spacingX.medium.textOnly'),
        paddingY: button('primary.spacingY.medium.textOnly'),
        lineHeight: button('primary.lineHeight.medium'),
        fontSize: button('primary.fontSize.medium'),
        fontWeight: button('primary.fontWeight.medium')
      },
      large: {
        borderRadius: button('primary.radius.large'),
        paddingX: button('primary.spacingX.large.textOnly'),
        paddingY: button('primary.spacingY.large.textOnly'),
        lineHeight: button('primary.lineHeight.large'),
        fontSize: button('primary.fontSize.large'),
        fontWeight: button('primary.fontWeight.large')
      }
    }
  });
};
export var widths = variant({
  prop: 'width',
  variants: {
    flexible: {
      width: 'auto'
    },
    fixed: {
      width: '100%'
    }
  }
});
export var loading = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  cursor: default;\n  .not-visible-when-loading {\n    visibility: hidden;\n  }\n\n  .spinner {\n    position: absolute;\n    margin-left: auto;\n    margin-right: auto;\n    left: 0;\n    right: 0;\n    text-align: center;\n  }\n"])));
export var disabled = function disabled(_ref3) {
  var button = _ref3.theme.button;
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  background-color: ", ";\n  cursor: not-allowed;\n"])), button('primary.disabledFontColor'), button('primary.disabledColor'));
};
export var hover = function hover(_ref4) {
  var button = _ref4.theme.button;
  return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  box-shadow: ", ";\n"])), button('primary.shadow'));
};
export var focus = function focus(_ref5) {
  var button = _ref5.theme.button;
  return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n  box-shadow: ", ";\n"])), button('primary.shadow'));
};
export var pressedBase = function pressedBase(_ref6) {
  var button = _ref6.theme.button;
  return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n  opacity: ", ";\n  position: absolute;\n  background-color: ", ";\n  border-radius: 50%;\n  transform: scale(0);\n  animation: ripple ", " linear;\n  transition: all ", ";\n\n  @keyframes ripple {\n    to {\n      transform: scale(4);\n      opacity: 0;\n    }\n  }\n"])), button('primary.opacity'), button('primary.pressedColor'), button('primary.rippleMotion'), button('primary.rippleMotion'));
};